import { translate } from 'helpers/translateHelper';
import React from 'react';
import { RadioButton } from 'sharedComponents';
import { BearingFaultFrequencies, BearingTypesToggleButton } from 'sharedComponents/Chart/headers';
import PropTypes from 'prop-types';
const BearingFaultHarmonics = (props) => {
    const {
        hasKpi,
        bearingFaultSwitch,
        setBearingFaultSwitch,
        hasBearingFaultFrequencies
    } = props;

    // Always show button, disable if not applicable, show tooltip
    const isDisabled = !hasBearingFaultFrequencies || !hasKpi;
    const getTooltipMessage = () => {
        if (!hasKpi) {
            return translate('ABB.Powertrain.Frontend.noDataAvailableTooltip');
        } else if (!hasBearingFaultFrequencies) {
            return translate('ABB.Powertrain.Frontend.noBearingConfigurationTooltip');
        } else {
            return '';
        }
    };
    return (
        <div className='bearing-fault-harmonics' title={isDisabled ? getTooltipMessage() : ''}>
            <div className='d-flex align-items-center'>
                <RadioButton
                    id={'bearing-fault-harmonics-radio'}
                    checked={bearingFaultSwitch}
                    onClick={() => !isDisabled && setBearingFaultSwitch(!bearingFaultSwitch)}
                    label={translate('ABB.Powertrain.Frontend.bearingFaultHarmonicsLabel')}
                    medium={true}
                    disabled={isDisabled}
                />
            </div>
            {bearingFaultSwitch &&
                <>
                    <BearingTypesToggleButton {...props} />
                    <div className='divider' />
                    <BearingFaultFrequencies {...props} />
                </>
            }
        </div>
    );
};

BearingFaultHarmonics.propTypes = {
    hasKpi: PropTypes.bool,
    bearingFaultSwitch: PropTypes.bool,
    setBearingFaultSwitch: PropTypes.func,
    selectedSpectrumRange: PropTypes.string,
    hasBearingFaultFrequencies: PropTypes.bool
};

export default BearingFaultHarmonics;
